import { TIMELINE_YEARS, at, bit, zeros } from './series.js';
/**
 * Amortissement linéaire, sans décomposition par composants (défaut F6, assumé).
 * Les montants d'amortissement sont **négatifs**, comme dans le classeur.
 */
export function buildDepreciation(params) {
    const { buildingBase, furnitureBase, buildingYears, furnitureYears, totalProjectCost, depreciating, inPortfolio, } = params;
    const building = { bop: zeros(), amortization: zeros(), eop: zeros() };
    const furniture = { bop: zeros(), amortization: zeros(), eop: zeros() };
    const bookValue = { bop: zeros(), depreciation: zeros(), eop: zeros() };
    // t = 0 : les valeurs sont posées, rien n'est encore amorti.
    building.bop[0] = buildingBase;
    building.eop[0] = buildingBase;
    furniture.bop[0] = furnitureBase;
    furniture.eop[0] = furnitureBase;
    bookValue.eop[0] = totalProjectCost;
    // F135 = 1 / années_deprec_meublé, F136 = 1 / durée du mobilier.
    const buildingRate = 1 / buildingYears;
    const furnitureRate = 1 / furnitureYears;
    for (let n = 1; n <= TIMELINE_YEARS; n++) {
        building.bop[n] = at(building.eop, n - 1);
        building.amortization[n] = -buildingBase * buildingRate * bit(depreciating[n]);
        building.eop[n] = at(building.bop, n) + at(building.amortization, n);
        // Le classeur câble 5 colonnes (H à L) puis des zéros figés. Ici la durée est un
        // paramètre : identique pour 5 ans, et cohérent si la durée change.
        furniture.bop[n] = at(furniture.eop, n - 1);
        furniture.amortization[n] = n <= furnitureYears ? -furnitureBase * furnitureRate : 0;
        furniture.eop[n] = at(furniture.bop, n) + at(furniture.amortization, n);
        const held = bit(inPortfolio[n]);
        bookValue.bop[n] = at(bookValue.eop, n - 1) * held;
        bookValue.depreciation[n] =
            (at(building.amortization, n) + at(furniture.amortization, n)) * held;
        bookValue.eop[n] = at(bookValue.bop, n) + at(bookValue.depreciation, n);
    }
    return { building, furniture, bookValue };
}
//# sourceMappingURL=depreciation.js.map